module.exports = __webpack_public_path__ + "static/media/zapier_ai.b68cd2fa.png";